<script>
import DatePicker from "vue2-datepicker"; // add DatePicker
import { required, minLength, maxLength } from "vuelidate/lib/validators";
export default {
  components: { DatePicker },
  props: {},
  data() {
    return {
      date_marty: "",
      place_marty: "",
      dept: "",
    };
  },
  validations: {
    date_marty: { required },
    place_marty: { required, minLength: minLength(2), maxLength: maxLength(50) },
    dept: { required, minLength: minLength(2), maxLength: maxLength(50) },

    form: ["date_marty", "place_marty", "dept"],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">معلومات الاستشهاد</h5></div>
      <b-form-group
        class="col-md-4 mb-3"
        label="تاريخ الاستشهاد : "
        label-for="date_marty"
      >
        <date-picker
          id="date_marty"
          type="date"
          lang="ar"
          value-type="DD-MM-YYYY"
          format="DD-MM-YYYY"
          placeholder="اختر تاريخ الاستشهاد"
          v-model="date_marty"
          :class="{ 'is-invalid': $v.date_marty.$error }"
        ></date-picker>
        <div v-if="$v.date_marty.$error" class="invalid-feedback">
          <span v-if="!$v.date_marty.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" محل الحادث : " label-for="place_marty">
        <b-form-input
          id="place_marty"
          type="text"
          placeholder="ادخل محل الحادث"
          v-model="place_marty"
          :class="{ 'is-invalid': $v.place_marty.$error }"
        ></b-form-input>
        <div v-if="$v.place_marty.$error" class="invalid-feedback">
          <span v-if="!$v.place_marty.required">هذا الحقل الزامي</span>
          <span v-if="!$v.place_marty.minLength"
            >يجب أن يتكون محل الحادث من حرفين على الأقل</span
          >
          <span v-if="!$v.place_marty.maxLength"
            >يجب أن يتكون محل الحادث من 50 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" التشكيل : " label-for="dept">
        <b-form-input
          id="dept"
          type="text"
          placeholder="ادخل التشكيل"
          v-model="dept"
          :class="{ 'is-invalid': $v.dept.$error }"
        ></b-form-input>
        <div v-if="$v.dept.$error" class="invalid-feedback">
          <span v-if="!$v.dept.required">هذا الحقل الزامي</span>
          <span v-if="!$v.dept.minLength">يجب أن يتكون التشكيل من حرفين على الأقل</span>
          <span v-if="!$v.dept.maxLength">يجب أن يتكون التشكيل من 50 حرف على الاكثر</span>
        </div>
      </b-form-group>
    </div>
  </div>
  <!-- end page title -->
</template>
